import { Clear } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";

import { AdornmentLens } from "@ryde/controls";
import { reportStartPageSearchAtom } from "@ryde/shared";

import { ReportMobileSettingsSearchWrapperStyled } from "../parts";

export const ReportStartPageSearch: FC = () => {
  const [searchText, setSearchText] = useRecoilState(reportStartPageSearchAtom);
  const { t } = useTranslation();
  return (
    <ReportMobileSettingsSearchWrapperStyled className="report_start_page_search">
      <TextField
        fullWidth
        label={t("general.SEARCH")}
        value={searchText}
        data-e2e="search-settings"
        autoComplete="off"
        size="small"
        onChange={e => setSearchText(e.target.value)}
        slotProps={{
          input: {
            startAdornment: <AdornmentLens />,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="Clear search field" // TODO: add translation solution/key ? if it is an actual label here and general maybe broader solution..
                  onClick={() => setSearchText("")}
                  edge="end"
                >
                  <Clear />
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />
    </ReportMobileSettingsSearchWrapperStyled>
  );
};
